import React, { useEffect } from 'react';
import { AIHero } from '../sections/ai/AIHero';
import { AIBenefits } from '../sections/ai/AIBenefits';
import { AIProcess } from '../sections/ai/AIProcess';
import { AIServices } from '../sections/ai/AIServices';
import { AIPricing } from '../sections/ai/AIPricing';
import { AIFAQ } from '../sections/ai/AIFAQ';
export const FractionalHeadOfAI = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-123">
      <AIHero data-id="element-124" />
      <AIBenefits data-id="element-125" />
      <AIProcess data-id="element-126" />
      <AIServices data-id="element-127" />
      <AIPricing data-id="element-128" />
      <AIFAQ data-id="element-129" />
    </main>;
};